import { render, staticRenderFns } from "./detailCustom.vue?vue&type=template&id=79cd9bfa&scoped=true&"
import script from "./detailCustom.vue?vue&type=script&lang=js&"
export * from "./detailCustom.vue?vue&type=script&lang=js&"
import style0 from "./detailCustom.vue?vue&type=style&index=0&id=79cd9bfa&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd9bfa",
  null
  
)

export default component.exports